import { v4 as uuidv4 } from "uuid";

type FileNameOpts = {
  prefix?: string;
  content?: string[];
  postfix?: string;
  fileExtension?: string;
};
export const generateFileName = ({
  prefix,
  content,
  postfix,
  fileExtension,
}: FileNameOpts): string => {
  let fileName = "";
  if (prefix) fileName = prefix;
  if (content?.length) {
    fileName = content.reduce((prevVal, curVal) => {
      if (!curVal) return prevVal;
      return !prevVal ? curVal : prevVal + `_${curVal}`;
    }, fileName);
  }
  if (postfix) fileName += fileName ? `_${postfix}` : postfix;

  if (fileExtension)
    fileName += fileName ? `.${fileExtension}` : `${uuidv4()}.${fileExtension}`;

  return fileName;
};

export const b64ToBlob = (
  b64Data: string,
  docType: "application/pdf" | "text/csv"
) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  const sliceSize = 512;

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: docType });
  return blob;
};

export const isWithContent = (reportText: string, report: Blob): boolean => {
  return reportText.indexOf("\r\n") + 2 !== report.size;
};

export const openFile = (file: Blob): string => {
  var fileURL = URL.createObjectURL(file);
  window.open(fileURL);
  return fileURL;
};
